import e, { memo as r, useContext as t } from "react";
import { RoughSVG as n } from "roughjs/bin/svg";
import { RoughCanvas as i } from "roughjs/bin/canvas";
var a = e.createContext({
  width: 300,
  height: 150,
  type: "canvas"
});

function u(e, r) {
  if (null == e) return {};
  var t,
      n,
      i = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) r.indexOf(t = a[n]) >= 0 || (i[t] = e[t]);

  return i;
}

function c(e) {
  return null == e || /^[sbn]/.test(typeof e);
}

a.displayName = "RoughContext";

var o = function (r) {
  var u = r.render,
      o = t(a),
      f = o.ref,
      l = o.config,
      s = o.width,
      d = o.height,
      h = o.type;
  return function (r, t) {
    var n, i;
    "production" !== process.env.NODE_ENV && function (e) {
      if (!e || !e.length) throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
      if (e.every(c)) throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
    }(t), e.useEffect(r, (function e(r, t) {
      var n, i;
      if (r === t) return !0;

      if (r && t && (n = r.constructor) === t.constructor) {
        if (n === Date) return r.getTime() === t.getTime();
        if (n === RegExp) return r.toString() === t.toString();

        if (n === Array && (i = r.length) === t.length) {
          for (; i-- && e(r[i], t[i]););

          return -1 === i;
        }

        if (n === Object) {
          if (Object.keys(r).length !== Object.keys(t).length) return !1;

          for (i in r) if (!(i in t) || !e(r[i], t[i])) return !1;

          return !0;
        }
      }

      return r != r && t != t;
    }(n = t, (i = e.useRef()).current) || (i.current = n), i.current));
  }(function () {
    var e = f && f.current;

    if (e) {
      if ("svg" === h) {
        var r = new n(e, l),
            t = u(r);
        return e.appendChild(t), function () {
          e.removeChild(t);
        };
      }

      var a = new i(e, l);
      u(a);
    }
  }, [f, l, u, h]), "canvas" === h && function () {
    if (!s || !d) throw new Error("Canvas should have a defined width and height");
    var e = f && f.current,
        r = e && e.getContext("2d");
    r && r.clearRect(0, 0, s, d);
  }(), null;
},
    f = r(function (r) {
  var t = r.x1,
      n = r.y1,
      i = r.x2,
      a = r.y2,
      c = u(r, ["x1", "y1", "x2", "y2"]),
      f = e.useCallback(function (e) {
    return e.line(t, n, i, a, c);
  }, [t, n, i, a, c]);
  return e.createElement(o, {
    render: function (e) {
      return f(e);
    }
  });
});

f.displayName = "Line";
var l = r(function (r) {
  var t = r.x,
      n = r.y,
      i = r.width,
      a = r.height,
      c = u(r, ["x", "y", "width", "height"]),
      f = e.useCallback(function (e) {
    return e.rectangle(t, n, i, a, c);
  }, [t, n, i, a, c]);
  return e.createElement(o, {
    render: function (e) {
      return f(e);
    }
  });
});
l.displayName = "Rectangle";
var s = r(function (r) {
  var t = r.x,
      n = r.y,
      i = r.width,
      a = r.height,
      c = u(r, ["x", "y", "width", "height"]),
      f = e.useCallback(function (e) {
    return e.ellipse(t, n, i, a, c);
  }, [t, n, i, a, c]);
  return e.createElement(o, {
    render: function (e) {
      return f(e);
    }
  });
});
s.displayName = "Ellipse";
var d = r(function (r) {
  var t = r.x,
      n = r.y,
      i = r.diameter,
      a = u(r, ["x", "y", "diameter"]),
      c = e.useCallback(function (e) {
    return e.circle(t, n, i, a);
  }, [t, n, i, a]);
  return e.createElement(o, {
    render: function (e) {
      return c(e);
    }
  });
});
d.displayName = "Circle";
var h = r(function (r) {
  var t = r.points,
      n = u(r, ["points"]),
      i = e.useCallback(function (e) {
    return e.linearPath(t, n);
  }, [t, n]);
  return e.createElement(o, {
    render: function (e) {
      return i(e);
    }
  });
});
h.displayName = "LinearPath";
var v = r(function (r) {
  var t = r.points,
      n = u(r, ["points"]),
      i = e.useCallback(function (e) {
    return e.polygon(t, n);
  }, [t, n]);
  return e.createElement(o, {
    render: function (e) {
      return i(e);
    }
  });
});
v.displayName = "Polygon";
var p = r(function (r) {
  var t = r.x,
      n = r.y,
      i = r.width,
      a = r.height,
      c = r.start,
      f = r.stop,
      l = r.closed,
      s = u(r, ["x", "y", "width", "height", "start", "stop", "closed"]),
      d = e.useCallback(function (e) {
    return e.arc(t, n, i, a, c, f, l, s);
  }, [t, n, i, a, c, f, l, s]);
  return e.createElement(o, {
    render: function (e) {
      return d(e);
    }
  });
});
p.displayName = "Arc";
var g = r(function (r) {
  var t = r.points,
      n = u(r, ["points"]),
      i = e.useCallback(function (e) {
    return e.curve(t, n);
  }, [t, n]);
  return e.createElement(o, {
    render: function (e) {
      return i(e);
    }
  });
});
g.displayName = "Curve";
var m = r(function (r) {
  var t = r.d,
      n = u(r, ["d"]),
      i = e.useCallback(function (e) {
    return e.path(t, n);
  }, [t, n]);
  return e.createElement(o, {
    render: function (e) {
      return i(e);
    }
  });
});
m.displayName = "Path";

var y = function (r) {
  var t = r.config,
      n = r.width,
      i = void 0 === n ? 300 : n,
      u = r.height,
      c = void 0 === u ? 150 : u,
      o = r.renderer,
      f = void 0 === o ? "canvas" : o,
      l = r.forwardedRef,
      s = r.children,
      d = e.useRef(),
      h = e.useRef();
  return l ? e.createElement(a.Provider, {
    value: {
      config: t,
      width: i,
      height: c,
      type: "canvas",
      ref: l
    }
  }, s) : "svg" === f ? e.createElement(a.Provider, {
    value: {
      config: t,
      type: "svg",
      ref: d
    }
  }, e.createElement("svg", {
    width: i,
    height: c,
    ref: d
  }, s)) : e.createElement(a.Provider, {
    value: {
      config: t,
      width: i,
      height: c,
      type: "canvas",
      ref: h
    }
  }, e.createElement("canvas", {
    width: i,
    height: c,
    ref: h
  }, s));
},
    w = e.forwardRef(function (r, t) {
  return e.createElement(y, Object.assign({}, r, {
    forwardedRef: t
  }));
});

w.displayName = "ReactRough";
export default w;
export { p as Arc, d as Circle, g as Curve, s as Ellipse, f as Line, h as LinearPath, m as Path, v as Polygon, w as ReactRough, y as ReactRoughComp, l as Rectangle };